import React, {
  createContext,
  FC,
  ReactNode,
  useEffect,
  useState,
} from "react";
import { AxiosError } from "axios";
import * as Sentry from "@sentry/browser";
import { NoTokenError } from "@rentablo/api";
import { useMyself } from "@api";

export const AuthContext = createContext<{
  setLoginRequired: (error: AxiosError<ApiException> | NoTokenError) => void;
}>({
  setLoginRequired: () => {
    // eslint-disable-next-line no-console
    console.warn("No <AuthProvider/> Found. Login form will not be shown.");
  },
});

interface Props {
  children: ReactNode;
  loginComponent: FC<{
    error?: AxiosError<ApiException> | NoTokenError;
    clearAuthStates?: () => void;
  }>;
}

export const AuthProvider = ({ children, loginComponent }: Props) => {
  const [loginRequired, setLoginRequired] = useState(false);
  const [error, setError] = useState<AxiosError<ApiException> | NoTokenError>();
  const { data: myself } = useMyself();

  useEffect(() => {
    if (myself) {
      Sentry.setUser({ id: String(myself.id), email: myself.email });
    }
  }, [myself]);

  const handleLoginRequired = (
    err: AxiosError<ApiException> | NoTokenError
  ) => {
    setLoginRequired(true);
    setError(err);
  };

  const clearStates = () => {
    setLoginRequired(false);
    setError(undefined);
  };

  // useEffect(() => {
  //   if (
  //     import.meta.env.VITE_APP_ENVIRONMENT === "production" &&
  //     loginRequired &&
  //     config?.links?.login
  //   ) {
  //     window.location.replace(config.links.login);
  //   }
  // }, [loginRequired, config]);
  //
  // if (
  //   config?.links?.login &&
  //   loginRequired &&
  //   import.meta.env.VITE_APP_ENVIRONMENT === "production"
  // )
  //   return null;

  return (
    <AuthContext.Provider value={{ setLoginRequired: handleLoginRequired }}>
      {loginRequired
        ? React.createElement(loginComponent, {
            error: error,
            clearAuthStates: clearStates,
          })
        : children}
    </AuthContext.Provider>
  );
};
